module.exports = __webpack_public_path__ + "static/media/logo_bw_ish.a709bb97.png";